import React from "react";
const Checkbox = ({ value, id, label, disabled, onChange, style }) => (
  <span onClick={!disabled ? onChange : () => {}} style={style}>
    <input type="checkbox" checked={value || false} readOnly />
    <label id={id}>{label}</label>
  </span>
);
export default Checkbox;
